import { render, staticRenderFns } from "./QuestionsStars.vue?vue&type=template&id=67d46ece&scoped=true"
import script from "./QuestionsStars.vue?vue&type=script&lang=js"
export * from "./QuestionsStars.vue?vue&type=script&lang=js"
import style0 from "./QuestionsStars.vue?vue&type=style&index=0&id=67d46ece&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d46ece",
  null
  
)

export default component.exports